import { FC, HTMLAttributes } from 'react'

export const PurpleInfoIcon: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="40" height="40" rx="20" fill="#2F3343" />
    <path
      d="M20 29.9993C25.5228 29.9993 30 25.5221 30 19.9993C30 14.4764 25.5228 9.99927 20 9.99927C14.4772 9.99927 10 14.4764 10 19.9993C10 25.5221 14.4772 29.9993 20 29.9993Z"
      stroke="#A35CFE"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 24V20"
      stroke="#A35CFE"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 15.9993H20.01"
      stroke="#A35CFE"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
